<template lang="pug">
  include ./../../../mixins
  +b.cards-industries
    +b.img--industries
      transition(name="fade")
        +b.IMG(
          :src='cardsObject.img'
          v-if="cardsObject.img"
        )
    +b.g-container--fit_auto-sm.--fit_md-md.--fit_lg-lg.--fit_auto_xl.--fit_auto_mac(
      style="width: 100%; height: 100%"
    )
      +b.g-row--align_center.rel.z--5.max_height
        +b.g-cols--6.--n_height.g-cell
          +b.nav-items
            +e.title(
              :class="index === 0 ? 'active':''"
              @mouseover="hoverMouse(item.title)"
              v-for="(item, index) in cards"
            )
              +b.P.ds-caption--c_white.--size_2md.--w_r.--h_130.--upp.--op-5 {{item.title}}

        +b.g-cols--6.g-cell
          transition(name="fade")
            +b.right-content(v-show="cardsObject.title")
              +b.el
                +b.H2.ds-caption--c_white.--size_30xl.--w_r.--h_130.--upp {{cardsObject.title}}
              +b.el--p_t_lg
                +b.P.ds-caption--c_white.--size_md.--w_r.--h_200.--op-4(v-html="cardsObject.text")
</template>

<script>

export default {
  data() {
    return {
      isHovering: false,
      cardsObject: {},
    }
  },
  props: {
    cards: {},
  },
  methods: {
    hoverMouse(data) {
      if (data !== this.cardsObject.title) {
        this.cardsObject = {}
      }
      const sleep = ms => new Promise(res => setTimeout(res, ms));
      (async () => {
        await sleep(150);
        this.cards.forEach(el => {
          if (data === el.title) {
            this.cardsObject = el
          }
        });
      })();
    },
  },
  mounted() {
    this.cards.forEach((el, index) => {
      if (index === 0) {
        this.cardsObject = el
      }
    });
    const navItems = document.querySelectorAll('.nav-items__title');
    function getClicked() {
      navItems.forEach(el => {
        el.classList.remove('active')
      });
      this.classList.add('active');
    }
    if (window.innerWidth >= 992 && navItems) {
      navItems.forEach(el => {
        el.addEventListener('mouseover', getClicked)
      });
    }
  },
}
</script>



// WEBPACK FOOTER //
// ./src/js/components/app/UiElements/CardsNavigate.vue